import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { InfoButton } from '../../../global';
import { Alert } from '../../../components';
import { PROGRESSIONS_MAX_NUM } from '../../../util/vars';

type Props = {
  updateView: React.ReactNode;
  setTopicButton: React.ReactNode;
  cancelTopicButton: React.ReactNode;
};

const Settings = ({ updateView, setTopicButton, cancelTopicButton }: Props): JSX.Element => {
  const { translate } = useI18n();
  const [ showInfo, setShowInfo ] = useState(false);

  return (
    <React.Fragment>
      <div className={'lg:flex items-center justify-between'}>
        <div className={'sm:flex flex-1 items-center mb-sm md:mb-0'}>
          <div>{updateView}</div>
        </div>
        <div className={'flex items-center justify-between'}>
          <div>{setTopicButton}</div>
          <div className={'mx-md'}>{cancelTopicButton}</div>
          <div>
            <InfoButton onClick={() => setShowInfo(!showInfo)} />
          </div>
        </div>
      </div>
      <div className={'w-full'}>
        <Alert show={showInfo} className={'mt-md'}>
          <div
            dangerouslySetInnerHTML={
              { __html: translate('pages.TOPIC.INFO', {
                progressions: PROGRESSIONS_MAX_NUM,
                interpolation: { 'escapeValue': false },
              }) }
            }
          />
        </Alert>
      </div>
    </React.Fragment>
  );
};

Settings.displayName = 'Settings';

export default Settings;
